<template>
  <div class="sidebar">
    <div class="logo-container">
      <img v-if="platformLogo" :src="platformLogo" class="logo-img" alt="" />
      <div v-else class="logo-mark">{{ shortName }}</div>
      <div v-if="sidebar.opened" class="logo-text">
        <h1 class="logo-title">{{ appName }}</h1>
        <p class="logo-sub">管理后台</p>
      </div>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="!sidebar.opened"
        :background-color="variables.sidebarBg"
        :text-color="variables.sidebarText"
        :active-text-color="'#fff'"
        :unique-opened="true"
        :collapse-transition="false"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  components: { SidebarItem },
  computed: {
    ...mapGetters(['appName', 'platformLogo']),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    shortName() {
      const name = this.appName || '小'
      return name.charAt(0)
    },
    routes() {
      return (this.$store.getters.permissionRoutes || []).filter(r => {
        if (!r || r.hidden || (r.meta && r.meta.hidden)) return false
        if (r.path === '*' || r.path === '/404' || r.path === '/login') return false
        // 纯重定向不进侧栏
        if (r.redirect && !r.component && !r.children) return false
        return true
      })
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) return meta.activeMenu
      return path
    },
    variables() {
      return {
        sidebarBg: '#0b1b33',
        sidebarText: 'rgba(255,255,255,0.72)',
        sidebarActive: '#165DFF'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: $sidebar-bg;
}

.logo-container {
  height: $navbar-height;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  background: $sidebar-bg;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.logo-img,
.logo-mark {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
}

.logo-img {
  object-fit: cover;
}

.logo-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  background: $primary;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}

.logo-text {
  min-width: 0;
  overflow: hidden;
}

.logo-title {
  margin: 0;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}

.logo-sub {
  margin: 1px 0 0;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.38);
}

::v-deep .el-scrollbar {
  height: calc(100% - #{$navbar-height});
  width: 100%;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

::v-deep .el-scrollbar__bar.is-horizontal {
  display: none !important;
}

::v-deep .el-menu {
  width: 100% !important;
  border-right: none;
  padding: 8px 0 20px;
  background: $sidebar-bg !important;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  height: 48px;
  line-height: 48px;
  margin: 0;
  border-radius: 0;
  min-width: 0 !important;
  overflow: hidden;
  background-color: transparent !important;

  i {
    color: inherit;
    margin-right: 10px;
    width: 18px;
    text-align: center;
  }
}

::v-deep .el-menu-item.is-active {
  background-color: $primary !important;
  color: #fff !important;
}

::v-deep .el-submenu__title:hover,
::v-deep .el-menu-item:hover {
  background-color: #132743 !important;
}

::v-deep .el-submenu .el-menu-item {
  padding-left: 52px !important;
  min-width: 0 !important;
  background-color: transparent !important;

  &:hover {
    background-color: #132743 !important;
  }

  &.is-active {
    background-color: $primary !important;
  }
}

::v-deep .el-menu--collapse {
  width: 100%;
}
</style>
